import React from "react";

const Submitted = () => {
    return <div>Submitted</div>;
};

export default Submitted;
